// extracted by mini-css-extract-plugin
module.exports = {"page-header":"HeaderSection_page-header__hS_Wa","page-header-mobile":"HeaderSection_page-header-mobile__pwCNM"};